import {doc} from '../docs.js';

doc(
    "repeatList",
    {
        "listToRepeat":"",
        "number of repeats":"",
    },
    "repeats an inputed list for a number of times",
    () => 1,
    {
        inlets: 2
    });

const repeatList = (object, repeats) => {
    return ([list]) => {
        let _list = [];
        let _repeats = repeats() || 1;
        for (let i=0; i < _repeats; i++) {
            for (let j=0; j < list.length; j++) {
                _list.push(list[j]);
            }
        }
        return [_list];
    };
};

export const listUtils = {
    repeatList
};
